<template>
  <div>
    <v-snackbar top v-model="snackbar">
      {{ text }}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab href="#" v-model="tabs" v-for="tab in tabs" :key="tab.name" @click="setActiveTabName(tab.name)">{{
          tab.displayName
        }}</v-tab>
      </v-tabs>
    </v-toolbar>
    <div v-if="displayContent('activeConnections')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="activeConnectionSearch" label="Search"></v-text-field>
      </v-toolbar>
      <v-data-table
        :search="activeConnectionSearch"
        :items="activeConnections"
        :headers="activeConnectionHeaders"
        :rows-per-page-items="[25, 50, 100]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon @click="deleteConnection(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">
            {{ props.item.connectedOrganisation.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.connectedOrganisation.organisationType.name }}
          </td>
          <td>
            <v-autocomplete
             :ref="props.item.id" v-on:blur="$refs[props.item.id].blur()"
              v-if="$store.state.currentOrg.org.accountingSystem == 'Xero' && !loading"
              :items="accountingCustomers"
              item-text="name"
              item-value="contactID"
              @change="updateAccountingId(props.item)"
              label="Accounting Profile"
              clearable
              v-model="props.item.accountingId"
            ></v-autocomplete>
            <v-progress-circular
              v-else-if="$store.state.currentOrg.org.accountingSystem == 'Xero' && loading"
              size="20"
              indeterminate
              color="grey"
            ></v-progress-circular>
            <v-autocomplete
             :ref="props.item.id" v-on:blur="$refs[props.item.id].blur()"
              v-else-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
              :items="accountingCustomers"
              item-text="name"
              item-value="id"
              clearable
              @change="updateAccountingId(props.item)"
              label="Accounting Profile"
              v-model="props.item.accountingId"
            ></v-autocomplete>
          </td>
          <td class="text-xs-center" @click="changeStatus(props.item)">
            <v-chip v-if="props.item.isLive == true" color="light-green" class="white--text">Live</v-chip>
            <v-chip v-else color="red" class="white--text">Inactive</v-chip>
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="displayContent('sentRequests')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="sentRequestSearch" label="Search"></v-text-field>
        <v-btn round color="primary" class="white--text" @click="newConnectionRequest()">New Request</v-btn>
      </v-toolbar>
      <v-data-table
        :search="sentRequestSearch"
        :items="sentRequests"
        :headers="sentRequestHeaders"
        :rows-per-page-items="[25, 50, 100]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon v-if="!props.item.isResolved" @click="deleteRequest()">delete</v-icon>
          </td>
          <td class="text-xs-center" v-if="!props.item.isResolved">
            <v-chip color="blue" class="white--text">Pending</v-chip>
          </td>
          <td class="text-xs-center" v-else>
            <v-chip color="light-green" class="white--text" v-if="props.item.isAccepted">Accepted</v-chip>
            <v-chip color="red" class="white--text" v-else-if="props.item.isRejected">Rejected</v-chip>
          </td>
          <td class="text-xs-center">
            {{ props.item.toOrganisation.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.message }}
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="displayContent('receivedRequests')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="sentRequestSearch" label="Search"></v-text-field>
        <v-btn round color="primary" class="white--text" @click="newConnectionRequest()">New Request</v-btn>
      </v-toolbar>
      <v-data-table
        :search="receivedRequestSearch"
        :items="receivedRequests"
        :headers="receivedRequestHeaders"
        :rows-per-page-items="[25, 50, 100]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout justify-center align-center v-if="!props.item.isResolved">
              <v-icon color="light-green" @click="acceptInvite(props.item)">check</v-icon>
              <v-icon color="red" @click="rejectInvite(props.item)">cancel</v-icon>
            </v-layout>
          </td>
          <td class="text-xs-center" v-if="!props.item.isResolved">
            <v-chip color="blue" class="white--text">Pending</v-chip>
          </td>
          <td class="text-xs-center" v-else>
            <v-chip color="light-green" class="white--text" v-if="props.item.isAccepted">Accepted</v-chip>
            <v-chip color="red" class="white--text" v-else-if="props.item.isRejected">Rejected</v-chip>
          </td>
          <td class="text-xs-center">
            {{ props.item.fromOrganisation.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.message }}
          </td>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="newConnectionRequestModal" width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">New Connection Request</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="(newConnectionRequestModal = false), (item = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center wrap>
            <v-flex xs4>
              <v-autocomplete
               ref="toOrganisationId" v-on:blur="$refs['toOrganisationId'].blur()"
                :items="organisations"
                label="Find Organisation"
                item-text="name"
                item-value="id"
                v-model="item.toOrganisationId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs10 mx-1>
              <v-textarea v-model="item.message" label="Message"></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center align-center>
            <v-btn round class="white--text" color="primary" @click="sendRequest()">Send Invite</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      activeTab: "",
      accountingCustomers: [],
      activeConnections: [],
      activeConnectionSearch: "",
      item: {},
      loading: true,
      newConnectionRequestModal: false,
      organisations: [],
      sentRequests: [],
      sentRequestSearch: "",
      receivedRequests: [],
      receivedRequestSearch: "",
      snackbar: false,
      text: "",
      tabs: [
        { name: "activeConnections", displayName: "Active Connections" },
        { name: "sentRequests", displayName: "Sent Requests" },
        { name: "receivedRequests", displayName: "Received Requests" },
      ],
      activeConnectionHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Organisation Type",
          align: "center",
          value: "organisationType.name",
        },
        {
          text: "Accounting Profile",
          align: "center",
          value: "accountingId",
        },
        {
          text: "Status",
          align: "center",
          value: "isLive",
        },
      ],
      receivedRequestHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Organisation",
          align: "center",
          value: "fromOrganisation.name",
        },
        {
          text: "Message",
          align: "center",
          value: "message",
        },
      ],
      sentRequestHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Organisation",
          align: "center",
          value: "toOrganisation.name",
        },
        {
          text: "Message",
          align: "center",
          value: "message",
        },
      ],
    };
  },
  created() {
    this.setActiveTabName("activeConnections");
    this.initialize();
  },
  methods: {
    initialize() {
      this.fetchBillingSettings()
      this.fetchActiveConnections();
      this.fetchSentRequests();
      this.fetchReceivedRequests();
      this.fetchOrganisations();
      
    },
     fetchBillingSettings(){
      Api().get('/organisation/billingSettings').then(async res=>{
        let billingSettings = res.data
        if (
        this.$store.state.currentOrg.org.isPrimaryOrganisation &&
        billingSettings.accountingSystem == "SageOne"
      ) {
        this.fetchSageCustomers();
      } else if (
        this.$store.state.currentOrg.org.isPrimaryOrganisation &&
        billingSettings.accountingSystem == "Xero"
      ) {
        this.getXeroContacts();
      }
        })},
    async fetchSageCustomers() {
      await Api()
        .get("/sageOne/customers")
        .then((res) => {
          let result = res.data.Results;
          result = result.map((x) => ({ id: x.ID.toString(), name: x.Name }));
          this.accountingCustomers = result;
        });
    },
    async getXeroContacts() {
      if (!this.$store.state.currentOrg.org.accountingId) {
        this.loading = false;
        confirm("Invalid Xero session data - please ask your organisation admin to update this info.");
      } else {
        Api()
          .get("/xero/contacts")
          .then((response) => {
            this.accountingCustomers = response.data.body.contacts;
            this.loading = false;
          });
      }
    },
    changeStatus(item) {
      Api()
        .put("/organisationConnection/" + item.id, {
          isLive: !item.isLive,
        })
        .then((response) => {
          this.fetchActiveConnections();
        });
    },
    updateAccountingId(item) {
      Api().put("/organisationConnection/" + item.id, { accountingId: item.accountingId });
    },
    newConnectionRequest() {
      this.item = {
        fromOrganisationId: this.$store.state.currentOrg.org.id,
        toOrganisationId: null,
        message: "",
        isResolved: false,
        isAccepted: false,
        isRejected: false,
      };
      this.newConnectionRequestModal = true;
    },
    sendRequest() {
      Api()
        .post("/organisationConnectionRequest", this.item)
        .then(() => {
          this.fetchSentRequests();
          this.newConnectionRequestModal = false;
          this.item = {};
          this.snackbar = true;
          this.text = "Successfully Sent Request!";
        });
    },
    acceptInvite(item) {
      Api()
        .post("/organisationConnectionRequest/accept/" + item.id, item)
        .then((response) => {
          this.fetchActiveConnections();
          this.fetchReceivedRequests();
          this.snackbar = true;
          this.text = "Invite from " + item.fromOrganisation.name + " accepted!";
        });
    },
    rejectInvite(item) {
      Api()
        .post("/organisationConnectionRequest/reject/" + item.id, item)
        .then((response) => {
          this.fetchActiveConnections();
          this.fetchReceivedRequests();
          this.snackbar = true;
          this.text = "Invite rejected!";
        });
    },
    fetchOrganisations() {
      Api()
        .get("/organisation/connections/unconnected")
        .then((response) => {
          console.log(response.data);
          this.organisations = response.data;
        });
    },
    fetchActiveConnections() {
      Api()
        .get("/organisationConnection")
        .then((response) => {
          this.activeConnections = response.data;
        });
    },
    fetchSentRequests() {
      Api()
        .get("/organisationConnectionRequest/sent")
        .then((response) => {
          this.sentRequests = response.data;
        });
    },
    fetchReceivedRequests() {
      Api()
        .get("/organisationConnectionRequest/received")
        .then((response) => {
          this.receivedRequests = response.data;
        });
    },
    deleteConnection(item) {
      confirm("Are you sure you want to remove the connection with " + item.connectedOrganisation.name + "?") &&
        Api()
          .post("/organisationConnection/delete", item)
          .then((res) => {
            this.fetchActiveConnections();
            this.snackbar = true;
            this.text = "Successfully removed connection!";
          });
    },
    setActiveTabName(tab) {
      this.activeTab = tab;
    },
    displayContent(tab) {
      return this.activeTab === tab;
    },
  },
};
</script>
